import axios from 'axios';

// Access the environment variable for your API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

// Request Interceptor: Attach the bearer token from localStorage to every outgoing request
// Request Interceptor: Attach the sessionGuid from localStorage to every outgoing request
api.interceptors.request.use(
    (config) => {
        // Remove the JWT token logic
        // const token = localStorage.getItem('access_token');
        // if (token) {
        //     config.headers.Authorization = `Bearer ${token}`;
        // }

        const sessionGuid = localStorage.getItem('access_token'); // Assuming you store it as 'session_guid'
        if (sessionGuid) {
            // Add sessionGuid as a query parameter
            // Ensure config.params exists
            config.params = {
                ...config.params, // Keep any existing query parameters
                sessionGuid: sessionGuid // Add your sessionGuid
            };
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: Global error handling (e.g., for 401 Unauthorized)
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('access_token');
            console.error('Unauthorized: Token might be invalid or expired. Logging out...', error.response);
        }
        // Reject the promise with the error response data for specific handling in components
        return Promise.reject(error.response ? error.response.data : error);
    }
);

export default api;